import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { FaEnvelope, FaFolderOpen, FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import ContactModal from "./ContactModal";
import Home2 from "./Home2";
import HomeShowcase from "./HomeShowcase";
import Type from "./Type";
import { useTranslation } from "../../i18n";

function Home() {
  const { t } = useTranslation();
  const nameParts = t("home.name").split(" ");
  const [showContact, setShowContact] = useState(false);

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                {t("home.greeting")}{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋
                </span>
              </h1>

              <h1 className="heading-name">
                {t("home.im")}
                {" "}
                <strong className="main-name">
                  {nameParts.map((part) => (
                    <span className="main-name-part" key={part}>
                      {part}
                    </span>
                  ))}
                </strong>
              </h1>

              <p className="home-hero-subtitle">
                {t("home.subtitle")}
              </p>

              <div className="home-highlight-row">
                <span>
                  <FaMapMarkerAlt /> {t("home.location")}
                </span>
                <span>{t("home.availability")}</span>
              </div>

              <div className="home-typewriter">
                <Type />
              </div>

              <div className="home-cta-row">
                <Button
                  as={Link}
                  to="/project"
                  className="home-cta-primary"
                >
                  <FaFolderOpen /> {t("home.viewWork")}
                </Button>
                <Button
                  type="button"
                  onClick={() => setShowContact(true)}
                  className="home-cta-secondary"
                >
                  <FaEnvelope /> {t("home.contactMe")}
                </Button>
              </div>
            </Col>

            <Col md={5} className="home-illustration-col">
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid home-illustration"
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
      <HomeShowcase />
      <ContactModal show={showContact} onHide={() => setShowContact(false)} />
    </section>
  );
}

export default Home;
